import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { PAReviewMeetingActionItemModel } from "@/store/models/paReview/paReviewMeetingActionItem";
let ReviewMeetingActionItems = /** @class */ (() => {
    var _a;
    let ReviewMeetingActionItems = class ReviewMeetingActionItems extends Mixins(BaseMixer) {
        editAction() {
            this.$emit("edit", this.action.id);
        }
        completeAction(needUpdate) {
            this.$emit("complete", this.action.id, needUpdate);
        }
        deleteAction() {
            this.$emit("delete", this.action.id);
        }
        created() { }
        destroyed() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof PAReviewMeetingActionItemModel !== "undefined" && PAReviewMeetingActionItemModel) === "function" ? _a : Object)
    ], ReviewMeetingActionItems.prototype, "action", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], ReviewMeetingActionItems.prototype, "isMeetingClosed", void 0);
    ReviewMeetingActionItems = __decorate([
        Component({
            name: "ReviewMeetingActionItems",
            components: {
                Loader,
            },
        })
    ], ReviewMeetingActionItems);
    return ReviewMeetingActionItems;
})();
export default ReviewMeetingActionItems;
